const formsList = [
  {
    type: "form",
    category: ["all", "purchase", "lease"],
    formNumber: "create-deal-sheet",
    title: "Creating your Deal Sheet",
  },
  {
    type: "section",
    category: ["all", "listing"],
    formNumber: null,
    title: "Listing Forms",
  },
  {
    type: "form",
    category: ["all", "listing"],
    formNumber: "proptx-mls-forms",
    title: "Generating your MLS Data Forms (PropTx)",
  },
  {
    type: "form",
    category: ["all", "listing"],
    formNumber: "itso-mls-forms",
    title: "Generating your MLS Data Forms (ITSO)",
  },
  {
    type: "form",
    category: "S",
    formNumber: "271",
    title: "Listing Agreement - For Sale (271)",
  },
  {
    type: "form",
    category: "T",
    formNumber: "272",
    title: "Listing Agreement - For Lease (272)",
  },
  {
    type: "form",
    category: ["all", "S"],
    formNumber: "240",
    title: "Amendment to Listing Agreement (240)",
  },
  {
    type: "form",
    category: ["all", "S"],
    formNumber: "161",
    title: "Registrant's Disclosure - Disposition (161)",
  },
  {
    type: "form",
    category: ["all", "S"],
    formNumber: "244",
    title: "Sellers Direction re: Property/Offers (244)",
  },
  {
    type: "form",
    category: "S",
    formNumber: "299",
    title: "Seller Disclosure: Latent Defect(s) (299)",
  },
  {
    type: "form",
    category: ["all", "S"],
    formNumber: "242",
    title: "Cancellation of Listing Agreement (242)",
  },
  {
    type: "form",
    category: ["all", "S"],
    formNumber: "241",
    title: "Suspension of Listing Agreement (241)",
  },
  {
    type: "form",
    category: "S",
    formNumber: "650",
    title: "Co-Brokerage Agreement (650)",
  },
  {
    type: "section",
    category: ["all", "listing"],
    formNumber: null,
    title: "Purchase/Lease Forms",
  },
  {
    type: "form",
    category: "B",
    formNumber: "371",
    title: "Buyer Representation Agreement (371)",
  },
  {
    type: "form",
    category: "T",
    formNumber: "372",
    title: "Tenant Representation Agreement (372)",
  },
  {
    type: "form",
    category: ["all", "purchase"],
    formNumber: "100",
    title: "Agreement of Purchase & Sale - Residential (100)",
  },
  {
    type: "form",
    category: ["all", "purchase"],
    formNumber: "101",
    title: "Agreement of Purchase & Sale - Condo (101)",
  },
  {
    type: "form",
    category: ["all", "purchase"],
    formNumber: "102",
    title: "Agreement of Purchase & Sale - Co-Operative (102)",
  },
  {
    type: "form",
    category: ["all", "purchase"],
    formNumber: "110",
    title: "Agreement of Purchase & Sale - Mobile/Modular/Manufactured (110)",
  },
  {
    type: "form",
    category: ["all", "purchase"],
    formNumber: "111",
    title: "Agreement of Purchase & Sale - POTL (111)",
  },
  {
    type: "form",
    category: "TL",
    formNumber: "400",
    title: "Agreement to Lease (400)",
  },
  {
    type: "form",
    category: "B",
    formNumber: "320",
    title: "Confirmation of Co-Operation and Representation (320)",
  },
  {
    type: "form",
    category: ["all", "purchase"],
    formNumber: "120",
    title: "Amendment to Agreement of Purchase & Sale (120)",
  },
  {
    type: "form",
    category: ["all", "purchase", "listing", "lease"],
    formNumber: "127",
    title: "Conditions in Offer - Buyer Acknowledgement (127)",
  },

  {
    type: "form",
    category: ["all", "B"],
    formNumber: "160",
    title: "Registrant's Disclosure - Acquisition (160)",
  },
  {
    type: "form",
    category: "B",
    formNumber: "325",
    title: "Multiple Representation Forms (325/326)",
  },
  {
    type: "form",
    category: ["all", "assignment"],
    formNumber: "145",
    title: "Assignment of Agreement of Purchase & Sale - Residential (145)",
  },
  {
    type: "form",
    category: ["all", "assignment"],
    formNumber: "150",
    title: "Assignment of Agreement of Purchase & Sale - Condo (150)",
  },
  {
    type: "section",
    category: ["all", "listing"],
    formNumber: null,
    title: "Additional Forms",
  },
  {
    type: "form",
    category: "SB",
    formNumber: "641",
    title: "Referral Agreement (641)",
  },
  {
    type: "form",
    category: ["all", "purchase", "listing", "lease"],
    formNumber: "124",
    title: "Notice of Fulfillment of Conditions (124)",
  },
  {
    type: "form",
    category: ["all", "purchase", "listing", "lease"],
    formNumber: "123",
    title: "Waiver (123)",
  },
  {
    type: "form",
    category: ["all", "purchase", "listing", "lease"],
    formNumber: "122",
    title: "Mutual Release (122)",
  },
  {
    type: "form",
    category: ["all", "purchase", "listing"],
    formNumber: "121",
    title: "Notice to Remove Conditions (121)",
  },
  {
    type: "form",
    category: ["all", "SB"],
    formNumber: "218",
    title: "Representation Agreement (218)",
  },
  {
    type: "form",
    category: ["all", "SB"],
    formNumber: "170",
    title: "Consent to Advertise (170)",
  },
  {
    type: "form",
    category: "SB",
    formNumber: "610",
    title: "Disclosure of Benefit (610)",
  },
];

export default formsList;
